<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col>
            <b-form @submit.prevent="saveItem">
              <b-card>
                <template slot="header">
                  <span class="pull-left mt-2">Tips & Tricks</span>
                </template>
                <b-row>
                  <b-col cols="12">
                    <b-form-group>
                      <ckeditor :editor="editor" v-model="item.tips_and_tricks" :disabled="!editable" :config="editorConfig"></ckeditor>
                    </b-form-group>
                  </b-col>
                </b-row>
                <template slot="footer">
                  <b-button type="submit" variant="success" class="pull-right" v-if="editable" :disabled="saveButtonDisabled">Opslaan</b-button>
                  <b-button @click="cancelEdit" class="pull-right mr-2" variant="warning" v-if="editable">Annuleer</b-button>
                  <b-button @click="editable = true" class="pull-right" variant="primary" v-if="!editable && userRole === 'admin'">Bewerken</b-button>
                </template>
              </b-card>
            </b-form>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import {updateData, getData} from '@/api';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  name: 'profile',
  props: ['id'],
  components: [
    ClassicEditor
  ],
  data () {
    return {
      saveButtonDisabled: false,
      editable: false,
      item: {},
      editor: ClassicEditor,
      editorConfig: {
        toolbar:  ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'insertTable'],
        table: {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
          ]
        },
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading2', view: 'h2', title: 'Heading 2'},
            { model: 'heading3', view: 'h3', title: 'Heading 3'},
            { model: 'heading4', view: 'h4', title: 'Heading 4'},
          ]
        }
      }
    }
  },
  methods: {
    async getItem() {
      const item = await getData('tips-and-tricks').then(response => response.data);
      this.item = item.data;
    },
    async saveItem() {
      this.errors = null;
      this.saveButtonDisabled = true;
      const request = await updateData('tips-and-tricks', this.item);
      if(request.status === 200) {
        this.editable = false;
        this.saveButtonDisabled = false;
        this.getItem();
      } else {
        this.editable = true;
        this.saveButtonDisabled = false;
      }
    },
    cancelEdit() {
      this.editable = false;
      this.getItem();
    },
  },
  computed: {
    userRole () {
      return this.$store.state.userRole
    }
  },
  beforeMount() {
    this.getItem();
  },

}
</script>

<style>
.ck-editor__editable_inline {
  min-height: 400px;
}
</style>
